var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-default",class:{'extra-small': _vm.extraSmall, 'small': _vm.small,
  'medium': _vm.medium, 'outline': _vm.outline, 'clen': _vm.clen, 'full': _vm.full},attrs:{"disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.description)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }